import type { InjectionKey, Ref } from "vue";

/**
 * Para onde dá para ir, nesta sessão.
 *
 * ── POR QUE ISTO É UM CONTRATO E NÃO UM IMPORT ────────────────────────────
 *
 * O catálogo de telas mora em `app/layout/nav-items.ts` (é ele que o menu e o
 * ⌘K leem, e é por isso que os dois não divergem), e as entidades vivas do
 * tenant chegam de `features/structure`. Quem precisa da lista é o agente, em
 * `features/agents` — e um feature não lê outro feature nem a moldura (SPEC §6).
 *
 * Então a lista viaja como as outras capacidades da casa viajam: declarada aqui,
 * provida pela moldura, injetada por quem precisa. É o mesmo desenho de
 * `ports.ts`, pela mesma razão.
 *
 * ── POR QUE ELA VIAJA NO TURNO ────────────────────────────────────────────
 *
 * O servidor não tem esta lista: `nav-items.ts` é arquivo do front. Uma segunda
 * cópia dela no back seria a lista à mão que este produto passou a fase 3
 * inteira eliminando — e ficaria velha na primeira tela que o tenant criasse.
 * São ~22 itens de ~60 caracteres; o preço é menor que o de uma tool call de
 * descoberta por turno.
 */
export interface Destination {
	/** Um caminho, como o `RouterLink` recebe. Nunca um `name` de rota. */
	readonly to: string;
	readonly label: string;
	/** O que a tela responde, em três a cinco palavras. */
	readonly hint: string;
}

export const DESTINATIONS: InjectionKey<Ref<readonly Destination[]>> = Symbol("DESTINATIONS");
